// 「カートに追加する」の真下に置く、カートへの導線。
//
// Dawn は追加後に「カートにアイテムが追加されました」の通知を出すが、
// 通知はヘッダーの直下に絶対配置される作りで、独自 CSS でヘッダーを固定している
// このテーマとは噛み合わない(位置は assets/coban.css の #cart-notification で直した)。
// それでも数秒で消えるため見落とされる。ボタンの下に常設リンクを置いて、
// カートに何か入っているときだけ出す。
//
// 件数は追加のたびに変わる。product-form.js が出す cartUpdate を受けて描き直す。
// cartUpdate の payload(/cart/add.js の応答)には追加後のカート全体の件数が
// 入っていないので、/cart.js を引き直している。
//
// テーマエディタはセクションを innerHTML で描き直すため、カスタム要素で書く。
class CobanCartLink extends HTMLElement {
  connectedCallback() {
    this.link = this.querySelector('a');
    // 「カートを見る ([count])」。翻訳は Liquid 側で解決して data 属性で渡している
    this.label = this.dataset.label || '';

    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, () => this.refresh());
  }

  disconnectedCallback() {
    if (this.unsubscribe) this.unsubscribe();
    this.unsubscribe = null;
  }

  async refresh() {
    try {
      const response = await fetch(`${window.routes.cart_url}.js`);
      if (!response.ok) throw new Error(response.status);
      const cart = await response.json();
      this.render(cart.item_count);
    } catch (error) {
      // 件数が取れなくても、追加が成功した直後ならカートには何か入っている。
      // 数字を出せないだけなのでリンクは見せる
      this.render(null);
    }
  }

  render(count) {
    this.hidden = count === 0;
    if (this.link && this.label && count !== null) {
      this.link.textContent = this.label.replace('[count]', count);
    }
  }
}

if (!customElements.get('coban-cart-link')) {
  customElements.define('coban-cart-link', CobanCartLink);
}
